"use strict";
var puntamentoInt = "https://arcol.albaleasing.eu/ileaf-microservices/api";
var puntamentoExt = "https://arcol.albaleasing.eu/ileaf-microservices/api";

function albaInit() {
  setTimeout(function () {
    appScaffolding(), scrollBar();
  }, 120);
}
var usingIE = !1,
  ua = window.navigator.userAgent;

function jsShowFlags() {
  $(".flag").popover({
    content: "<ul class='flag-list'><li><span class='flag it'></span></li><li><span class='flag en'></span></li><li><span class='flag fr'></span></li></ul>",
    placement: "bottom",
  });
}

function customAnimation() {
  $(".custom-animation").each(function () {
    $(this).addClass("discovered");
  });
  var e = {
    init: function () {
      (this.browser = this.searchString(this.dataBrowser) || "Other"),
        (this.version =
          this.searchVersion(navigator.userAgent) ||
          this.searchVersion(navigator.appVersion) ||
          "Unknown");
    },
    searchString: function (e) {
      for (var r = 0; r < e.length; r++) {
        var t = e[r].string;
        if (
          ((this.versionSearchString = e[r].subString),
            -1 !== t.indexOf(e[r].subString))
        )
          return e[r].identity;
      }
    },
    searchVersion: function (e) {
      var r = e.indexOf(this.versionSearchString);
      if (-1 !== r) {
        var t = e.indexOf("rv:");
        return "Trident" === this.versionSearchString && -1 !== t ?
          parseFloat(e.substring(t + 3)) :
          parseFloat(e.substring(r + this.versionSearchString.length + 1));
      }
    },
    dataBrowser: [{
      string: navigator.userAgent,
      subString: "Edge",
      identity: "MS Edge"
    },
    {
      string: navigator.userAgent,
      subString: "MSIE",
      identity: "Explorer"
    },
    {
      string: navigator.userAgent,
      subString: "Trident",
      identity: "Explorer",
    },
    {
      string: navigator.userAgent,
      subString: "Firefox",
      identity: "Firefox",
    },
    {
      string: navigator.userAgent,
      subString: "Opera",
      identity: "Opera"
    },
    {
      string: navigator.userAgent,
      subString: "OPR",
      identity: "Opera"
    },
    {
      string: navigator.userAgent,
      subString: "Chrome",
      identity: "Chrome"
    },
    {
      string: navigator.userAgent,
      subString: "Safari",
      identity: "Safari"
    },
    ],
  };
  e.init(),
    "Explorer" == e.browser && "10" == e.version ?
      $("html").addClass("msie-10") :
      "Explorer" == e.browser &&
      "11" == e.version &&
      $("html").addClass("msie-11"),
    (usingIE = "Explorer" == e.browser);
}

function scrollBar(e) {
  900 < $(window).width() ?
    ($(".alb-scroll").length &&
      ($(".alb-scroll").mCustomScrollbar({
        theme: "dark",
        scrollbarPosition: "outside",
      }),
        null != e &&
        $(".alb-scroll.recovery-scroll").length &&
        $(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0)),
      $(".table-responsive") &&
      $(".table-responsive").mCustomScrollbar({
        theme: "dark",
        axis: "x",
        mouseWheel: !1,
      })) :
    $(".alb-scroll").addClass("ovw-hidden ovw-scroll-y");
}

function appScaffolding() {
  setChildHeight();
}

function setChildHeight() {
  var e = $(window).height(),
    r = $(".page-content-wrapper"),
    t = $("header"),
    n = $("footer"),
    i = e - (t.height() + n.height()) - 40;
  r.css({
    height: i + "px"
  }),
    $(".alb-height").each(function () {
      var e = $(this).data("height-perc"),
        r = $(this).data("margin"),
        t = (parseFloat(i) * parseFloat(e)) / 100;
      $(this).css("height", t - r + "px");
    });
} -
  1 != ua.indexOf("Apple-") && $("html").addClass("is-apple-device"),
  (Number.isInteger =
    Number.isInteger ||
    function (e) {
      return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
    }),
  Array.prototype.findIndex ||
  Object.defineProperty(Array.prototype, "findIndex", {
    value: function (e) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var r = Object(this),
        t = r.length >>> 0;
      if ("function" != typeof e)
        throw new TypeError("predicate must be a function");
      for (var n = arguments[1], i = 0; i < t;) {
        var o = r[i];
        if (e.call(n, o, i, r)) return i;
        i++;
      }
      return -1;
    },
  }),
  Array.prototype.find ||
  Object.defineProperty(Array.prototype, "find", {
    value: function (e) {
      if (null == this)
        throw new TypeError(
          "Array.prototype.find called on null or undefined"
        );
      if ("function" != typeof e)
        throw new TypeError("predicate must be a function");
      for (
        var r = Object(this), t = r.length >>> 0, n = arguments[1], i = 0; i !== t; i++
      )
        if (e.call(n, this[i], i, r)) return this[i];
    },
  }),
  Object.assign ||
  Object.defineProperty(Object, "assign", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function (e, r) {
      if (null == e)
        throw new TypeError("Cannot convert first argument to object");
      for (var t = Object(e), n = 1; n < arguments.length; n++) {
        var i = arguments[n];
        if (null != i) {
          i = Object(i);
          for (
            var o = Object.keys(Object(i)), a = 0, s = o.length; a < s; a++
          ) {
            var c = o[a],
              l = Object.getOwnPropertyDescriptor(i, c);
            void 0 !== l && l.enumerable && (t[c] = i[c]);
          }
        }
      }
      return t;
    },
  }),
  String.prototype.includes ||
  (String.prototype.includes = function (e, r) {
    return (
      "number" != typeof r && (r = 0),
      !(r + e.length > this.length) && -1 !== this.indexOf(e, r)
    );
  }),
  Array.prototype.equalsArrayObject;
var isMenuDisabled = !(Array.prototype.equalsArrayObject = function (e) {
  if (!e) return !1;
  if (this.length != e.length) return !1;
  for (var r = 0, t = this.length; r < t; r++)
    for (var n in this[r])
      if (this[r][n] != e[r][n]) return !1;
  return !0;
});

function getMenuState() {
  return isMenuDisabled;
}

function setMenuState(e) {
  isMenuDisabled = e;
}

function pswRecoveryBlock() {
  openPswRecovery();
}

function pswRecoveryBlockNuArc() {
  openPswRecoveryNuArc();
}

function openPswRecoveryNuArc() {
  (isMenuDisabled = !0),
    setTimeout(function () {
      $(".rcv-form").stop(),
        $(".rcv-form").show(),
        setTimeout(function () {
          $(".bg-header").stop(),
            $(".rcv-form").stop(),
            $(".bg-header").animate({
              "margin-top": "820px"
            },
              250,
              function () {
                $(".rcv-form").animate({
                  opacity: "1"
                }, 900, function () {
                  $(".bg-header").addClass("opty"),
                    $(".overlay-formRecovery").addClass("opty"),
                    $(".mid-content").addClass("opty");
                });
              }
            );
        }, 130);
    }, 150);
}



function openPswRecovery() {
  (isMenuDisabled = !0),
    setTimeout(function () {
      $(".rcv-form").stop(),
        $(".rcv-form").show(),
        setTimeout(function () {
          $(".bg-header").stop(),
            $(".rcv-form").stop(),
            $(".bg-header").animate({
              "margin-top": "500px"
            },
              250,
              function () {
                $(".rcv-form").animate({
                  opacity: "1"
                }, 900, function () {
                  $(".bg-header").addClass("opty"),
                    $(".overlay-formRecovery").addClass("opty"),
                    $(".mid-content").addClass("opty");
                });
              }
            );
        }, 130);
    }, 150);
}

function closePswRecovery() {
  $(".close-rcvry");
  $(".rcv-form").stop(),
    $(".rcv-form").animate({
      opacity: "0"
    }, 250, function () {
      $(".bg-header").stop(),
        $(".bg-header").animate({
          "margin-top": "0"
        }, 270, function () {
          $(".bg-header").removeClass("opty"),
            $(".mid-content").removeClass("opty"),
            $(".overlay-formRecovery").removeClass("opty"),
            $(".rcv-form").hide(400, function () {
              $(".home-view.alb-scroll").css("height", "auto");
            });
        });
    }),
    (isMenuDisabled = !1);
}


function openDelegaAttivita() {
  (isMenuDisabled = !0),
    setTimeout(function () {
      $(".delegaAttivita").stop(),
        $(".delegaAttivita").show(),
        setTimeout(function () {
          $(".bg-header").stop(),
            $(".delegaAttivita").stop(),
            $(".bg-header").animate({
              "margin-top": "250px"
            },
              250,
              function () {
                $(".delegaAttivita").animate({
                  opacity: "1"
                }, 900, function () {
                  $(".bg-header").addClass("opty"),
                    $(".mid-content").addClass("opty");
                });
              }
            );
        }, 130);
    }, 500);
}

function closeDelegaAttivita() {
  $(".close-rcvry");
  $(".delegaAttivita").stop(),
    $(".delegaAttivita").animate({
      opacity: "0"
    }, 250, function () {
      $(".bg-header").stop(),
        $(".bg-header").animate({
          "margin-top": "0"
        }, 270, function () {
          $(".bg-header").removeClass("opty"),
            $(".mid-content").removeClass("opty"),
            $(".delegaAttivita").hide(400, function () {
              $(".home-view.alb-scroll").css("height", "auto");
            });
        });
    }),
    (isMenuDisabled = !1);
}



function cleanRecoveryPasswordFields() {
  $("form[name=FormChangePassword]")
    .find("input:password")
    .each(function () {
      $(this).val(""),
        $(this).removeClass(
          "ng-dirty ng-touched ng-invalid has-error ng-not-empty"
        );
    });
}

function rotationBlock() {
  $(window).width() < 150 ?
    $("html").append(
      "<div class='overlay-block'><i class=\"icon icon-ruota-dispositivo\"></i></div>"
    ) :
    $(".overlay-block").remove();
}
$(window).on("resize", function () {
  rotationBlock();
});
var cfChecker = {
  ottieni_consonanti: function (e) {
    return e.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi, "");
  },
  ottieni_vocali: function (e) {
    return e.replace(/[^AEIOU]/gi, "");
  },
  calcola_codice_cognome: function (e) {
    var r = this.ottieni_consonanti(e);
    return (
      (r += this.ottieni_vocali(e)),
      (r = (r += "XXX").substr(0, 3)).toUpperCase()
    );
  },
  calcola_codice_nome: function (e) {
    var r = this.ottieni_consonanti(e);
    return (r =
      4 <= r.length ?
        r.charAt(0) + r.charAt(2) + r.charAt(3) :
        ((r += this.ottieni_vocali(e)),
          (r += "XXX").substr(0, 3))).toUpperCase();
  },
  validateCfFromInfo: function (e, r) {
    if (
      !(
        e.Anno &&
        e.Anno.value &&
        !(e.Anno.value.length < 4) &&
        e.Giorno &&
        e.Giorno.value &&
        e.Mese &&
        e.Mese.value &&
        e.cf &&
        e.cf.value &&
        e.cognome &&
        e.cognome &&
        e.nome &&
        e.nome &&
        e.sesso &&
        e.sesso.value &&
        e.provincia &&
        e.comune
      )
    )
      return !1;
    var t, n, i, o, a, s;
    if ("" == (t = e.cf.value.toUpperCase().trim())) return !1;
    if (!/^[A-Z0-9]{16}$/.test(t)) return !1;
    var c,
      l = t.substr(11, 4);
    if ("EE" != e.provincia) {
      var u = mapComuni.find(function (e) {
        return e.codiceCatastale == l;
      });
      if (
        u &&
        (e.comune.toUpperCase() != u.nome.toUpperCase() ||
          e.provincia != u.sigla)
      )
        return !1;
    } else if ("EE" == e.provincia) {
      var f = r.find(function (e) {
        return e.value == l;
      });
      if (f && e.comune != f.name) return !1;
    }
    for (
      o = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      a = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ",
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      "BAKPLCQDREVOSFTGUHMINJWZYX",
      i = 0,
      n = 1; n <= 13; n += 2
    )
      i += "ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(
        a.charAt(o.indexOf(t.charAt(n)))
      );
    for (n = 0; n <= 14; n += 2)
      i += "BAKPLCQDREVOSFTGUHMINJWZYX".indexOf(
        a.charAt(o.indexOf(t.charAt(n)))
      );
    if (i % 26 != t.charCodeAt(15) - "A".charCodeAt(0)) return !1;
    if (e.cf.value.substr(3, 3) != this.calcola_codice_nome(e.nome)) return !1;
    if (e.cf.value.substr(0, 3) != this.calcola_codice_cognome(e.cognome))
      return !1;
    if (t.substr(6, 2) != e.Anno.value.substr(2, 2)) return !1;
    switch (e.Mese.value) {
      case "01":
        c = "A";
        break;
      case "02":
        c = "B";
        break;
      case "03":
        c = "C";
        break;
      case "04":
        c = "D";
        break;
      case "05":
        c = "E";
        break;
      case "06":
        c = "H";
        break;
      case "07":
        c = "L";
        break;
      case "08":
        c = "M";
        break;
      case "09":
        c = "P";
        break;
      case "10":
        c = "R";
        break;
      case "11":
        c = "S";
        break;
      case "12":
        c = "T";
    }
    return (
      t.substr(8, 1) == c &&
      ("M" == e.sesso.value ?
        (s = e.Giorno.value) :
        "F" == e.sesso.value &&
        (s =
          0 == parseInt(e.Giorno.value) ?
            parseInt(e.Giorno.value.substr(1, 1)) + 40 :
            parseInt(e.Giorno.value) + 40),
        t.substr(9, 2) == s)
    );
  },
};
/Android/.test(navigator.appVersion) &&
  window.addEventListener("resize", function () {
    ("INPUT" != document.activeElement.tagName &&
      "TEXTAREA" != document.activeElement.tagName) ||
      window.setTimeout(function () {
        document.activeElement.scrollIntoViewIfNeeded();
      }, 0);
  });

function changeBeService(value) {

  if (location.protocol == 'https:') {
    return puntamentoExt;

  } else {
    return puntamentoInt;
  }

}

function appendToForm(formData, name, value) {
  value && formData.append(name, value);
}

function restrictTo8859(f) {
  //!(/[^\u0000-\u00ff]/gi).test(f.value) ? f.value = f.value.replace(/[\u0000-\u00ff]/gi,''):null;
  // !(/[^\u0000-\u001f]/gi).test(f.value) ? f.value = f.value : null;
  // !(/[^\u0080-\u009f]/gi).test(f.value) ? f.value = f.value : null;
  // !(/[^\u0100-\uffff]/gi).test(f.value) ? f.value = f.value : null;
  // !(/^[\w\-\s@\.\+\*\?\$\(\)\]\[\{\}\|\\!"'&\/=:_><]+$/gi).test(f.value) ? f.value = f.value : null;
  var temp = f.value.replace(/[\u0000-\u001f]/gi, '').replace(/[\u0080-\u009f]/gi, '').replace(/[\u0100-\uffff]/gi, '').replace(/^[\w\-\s@\.\+\*\?\$\(\)\]\[\{\}\|\\!"'&\/=:_><]+$/gi, '')
  return temp;
}

function calculateEasterDays(anno) {
  if (!anno) {
    var anno = new Date().getFullYear();
  }
  var days = [];
  var M = 0;
  var N = 0;
  if (anno < 2100) {
    M = 24;
    N = 5;
  } else if (anno < 2200 && anno >= 2100) {
    M = 24;
    N = 6;
  } else if (anno < 2300 && anno >= 2200) {
    M = 25;
    N = 6;
  }
  var a = anno % 19;
  var b = anno % 4;
  var c = anno % 7;
  var d = (19 * a + M) % 30;
  var e = (2 * b + 4 * c + 6 * d + N) % 7;

  var test = d + e;
  if (test < 10) {
    var pasqua = d + e + 22;
    console.log("Pasqua: " + pasqua + " Marzo");
    if (pasqua == 31) {
      pasquetta = "01/04"
    } else {
      pasquetta = pasqua + 1
    }
    return pasqua + "/03"
  } else {
    var pasqua = d + e - 9;
    if (pasqua == 26) {
      pasqua = 19;
    } else if (pasqua == 25 && d == 28 && e == 6 && a > 10) {
      pasqua = 18;
    }
    console.log("Pasqua: " + pasqua + " Aprile");
    return pasqua + "/04"
  }
}

function cleanPvModel(model, applicationName) {
  applicationName = applicationName.toUpperCase();
  var functionality = "";
  switch (applicationName) {
    case "CESSIONE":
    case "VOLTURA":
      functionality = 'cessioneVoltura';
      break;

    case "AGGIORNAMENTO_DOC_IDENTITA":
      functionality = 'aggiornamentoDocumenti';
      break;

    case "IMM_AUT_COMUNALE":
      functionality = 'autorizzazioneComunale';
      break;

    case "IMM_DELEGHE":
      functionality = 'delega';
      break;

    case "IMM_SOTTOSCRIZIONE_CATASTALE":
      functionality = 'sottoscrizioneCatastale';
      break;

    case "RISCATTO":
      functionality = 'riscattoAnticipato';
      break;

    case "VARIAZIONE_ANAGRAFICA_CSC":
    case "VARIAZIONE_ANAGRAFICA_SOC":
    case "VARIAZIONE_INDIRIZZO_INSTALLAZIONE":
      functionality = 'variazioneAnagrafica';
      break;

    case "VARIAZIONE_COORDINATE_BANCARIE":
      functionality = 'coordinateBancarie'
      break;

    case "VARIAZIONE_TARGATO":
      functionality = 'contrattoTargato';
      break;

    default:
      functionality = "";
      break;
  }
  Object.keys(model).forEach(function (element) {
    if (!!functionality && element != functionality && typeof model[element] == "object" && !Array.isArray(model[element])) {
      delete model[element];
    }
  })
}